module.exports = __webpack_public_path__ + "static/avenir-next-d8ee249af8ca02024e208e88ecb52990.woff2";